'use client';

import React from 'react';
import { useParams } from 'next/navigation';

import { doTranslation } from '@/app/i18n/client';

import styles from '@/components/schedule-results/rating-stars.module.scss';

type Props = {
  score: number;
  hasRatings: boolean;
};

const RatingStars = (props: Props): React.JSX.Element => {
  const { lng }: any = useParams();

  const { t } = doTranslation(lng);
  const { hasRatings, score } = props;

  if (!hasRatings) {
    return (
      <div className={styles.stars} aria-label={t('Not yet rated')} role="img">
        {[...Array(5)].map((_, i) => (
          <span key={`empty-${i}`} className={styles.empty} />
        ))}
      </div>
    );
  }

  const fullStars = Math.floor(score);
  const hasHalfStar = score % 1 >= 0.3 && score % 1 <= 0.9;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div
      className={styles.stars}
      aria-label={t('{{ score }} Stars', {
        score: score
      })}
      role="img"
    >
      {[...Array(fullStars)].map((_, i) => (
        <span key={`full-${i}`} className={styles.full} />
      ))}
      {hasHalfStar && <span className={styles.half} />}
      {[...Array(emptyStars)].map((_, i) => (
        <span key={`empty-${i}`} className={styles.empty} />
      ))}
    </div>
  );
};

export default RatingStars;
